// components/sections/BirthInformation.tsx
import React from 'react';
import { Registry } from '@/graphql/__generated__/onboarding';
import { MexStates } from '@/utils/maps';
import TextSection from './TextSection';

interface BirthInformationProps {
	registry: Registry;
	onChangeRequest: (
		e: React.ChangeEvent<HTMLInputElement>,
		section: string,
		field: string,
		value: any
	) => void;
	changesRequested: Array<{ section: string; field: string; value: any }>;
	cantRequestChangesFromFields: string[];
}

export const BirthInformation: React.FC<BirthInformationProps> = ({
	registry,
	onChangeRequest,
	changesRequested,
	cantRequestChangesFromFields
}) => {
	return (
		<div className="space-y-3">
			<TextSection
				label="DateOfBirth"
				value={registry.birthInformation?.dateOfBirth}
				field="DateOfBirth"
				sectionName="BirthInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="CountryOfBirth"
				value={registry.birthInformation?.countryOfBirth}
				field="CountryOfBirth"
				sectionName="BirthInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="StateOfBirth"
				value={
					registry.birthInformation?.mexStateOfBirth
						? MexStates[registry.birthInformation.mexStateOfBirth]
						: null
				}
				field="MexStateOfBirth"
				sectionName="BirthInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
		</div>
	);
};

export default BirthInformation;
